import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const getSchemaValidation = () => {
  const { t } = useTranslation();
  const emailRegex = /^[a-zA-Z0-9_.-]{2,}\.[a-zA-Z0-9_.-]+$/;

  return yup.object().shape({
    domain: yup
      .string()
      .required(t("validation.required"))
      .matches(emailRegex, t("validation.invalid_email")),
  });
};
